import FloatingLayer from "./FloatingLayer";
import StandardFloatingLayer from "./StandardFloatingLayer";

export {
    FloatingLayer,
    StandardFloatingLayer
};